import { MenuItem, TextField } from '@mui/material';
import { preferredTermOptions } from './serviceRequestModel';

interface PreferredTermFieldProps {
  disabled: boolean;
  value: string[];
  onChange: (value: string[]) => void;
}

/** The preferred contract terms of a New Service. */
export function PreferredTermField({ disabled, value, onChange }: PreferredTermFieldProps) {
  return (
    <div style={{ breakInside: 'avoid', marginBottom: '1.5rem' }}>
      <TextField
        select
        sx={{ width: '100%' }}
        label="Preferred Term"
        id="preferred_term_select"
        value={value}
        data-cy="preferred_term"
        size="small"
        aria-label="preferred term"
        disabled={disabled}
        SelectProps={{
          multiple: true,
          renderValue: (selected) => (selected as string[]).join(', ')
        }}
        onChange={(e) => onChange(e.target.value as unknown as string[])}>
        {preferredTermOptions.map((option) => (
          <MenuItem
            key={option}
            value={option}>
            {option}
          </MenuItem>
        ))}
      </TextField>
    </div>
  );
}
